<script setup>
import { ref, computed, onMounted, watch } from "vue"
import { storage } from '../storage'
import { boostDuration, upgrades } from '../staticData'
import { stringNumber, getCoinUrl } from '../helpers/functions.js'
import config from '../set_config.json'
import { updateStarsSpeed } from '../helpers/renderer.js'


const props = defineProps(['earningsPerS', 'activateBoost'])
const isBoostAvailable = ref(true)
const nextBoostTimerStr = ref(null)
const timerStr = ref(null)
// const boostNum = ref(upgrades.extraBoost.values[storage.UPGRADES_LVLS.extraBoost])
onMounted(() => {
    if (storage.BOOST_ON) {
        const boostEnd = new Date(+(new Date(storage.NEXT_BOOST_TIME) - 2 * 60 * 1000))
        // storage.NEXT_BOOST_TIME = null
        console.log('next boost', boostEnd)
        toBoostUp(null, boostEnd)
    }
    else if (new Date(storage.NEXT_BOOST_TIME) > new Date()) {
        nextBoostTimer(storage.NEXT_BOOST_TIME)
    }
})
const isActive = computed(() => props.activateBoost)
watch(isActive, () => {
    if (isActive.value) {
        console.log('Add has changed')
        boostTimerManager(null)
    }
})
function toBoostUp(__, nextTime) {
    if (storage.NEXT_BOOST_TIME && storage.NEXT_BOOST_TIME > new Date() && !nextTime) return
    isBoostAvailable.value = false
    // storage.BOOST_ON = true
    storage.BOOST_NUM = upgrades.extraBoost.values[storage.UPGRADES_LVLS.extraBoost]
    // console.log('nextTime ', nextTime)

    storage.NEXT_BOOST_TIME = nextTime ? new Date(storage.NEXT_BOOST_TIME) : new Date(+new Date() + 2 * 60 * 1000 + boostDuration)
    // console.log('NEXT ', storage.NEXT_BOOST_TIME)

    if (nextTime) boostTimerManager(nextTime)
    else if (typeof gdsdk !== 'undefined' && typeof gdsdk.showAd !== 'undefined') {
        console.log("DEBUG: ad should be in progress")
        gdsdk.showAd('rewarded')
            .then()
            .catch(error => console.log('Error with showing the ADD', error));
    } else if (config.isDev) {
        boostTimerManager(nextTime)
    }

}

const nextBoostTimer = (endTime) => {
    isBoostAvailable.value = false
    nextBoostTimerStr.value = timerUpdater(endTime)
    // console.log('DEBUG nextBoost INTERVAL IS SET')
    const boostInt = setInterval(() => {
        nextBoostTimerStr.value = timerUpdater(endTime)
        if (nextBoostTimerStr.value === "00:00") {
            // storage.NEXT_BOOST_TIME = null
            nextBoostTimerStr.value = null
            isBoostAvailable.value = true
            // gameData.tillNextBoost = 0
            // console.log('DEBUG INTERVAL IS CLEARED')

            clearInterval(boostInt)
        }
    }, 900)
}
function boostTimerManager(nextTime = null) {
    console.log('BOOOST MANAGER IS ON has changed')

    storage.BOOST_ON = true
    const spaceSpeed = setInterval(() => {
        updateStarsSpeed()
    }, 300)
    const boostEndTime = nextTime ? nextTime : new Date(+new Date() + boostDuration)
    timerStr.value = timerUpdater(boostEndTime)
    const boostTimer = setInterval(() => {
        timerStr.value = timerUpdater(boostEndTime)
        if (timerStr.value === "00:00") {
            timerStr.value = null
            storage.BOOST_ON = false
            // gameData.tillNextBoost = new Date(+new Date() + 2 * 60 * 1000)
            // if (config.isDev || config.isShort) gameData.tillNextBoost = new Date(+new Date() + 10 * 1000)
            // console.log('NEXT ', storage.NEXT_BOOST_TIME)
            nextBoostTimer(storage.NEXT_BOOST_TIME)
            clearInterval(boostTimer)
            clearInterval(spaceSpeed)
        }
    }, 900)
}

function timerUpdater(endTime) {
    const var2 = new Date(endTime) - new Date();

    if (!var2 || var2 <= 0) return "00:00";

    let min = Math.floor(var2 / 60 / 1000)
    min = min < 0 ? 0 : min;
    if (min < 10)
        min = "0" + min;

    let sec = Math.floor(((var2 % 60000) / 1000))
    sec = sec < 0 ? 0 : sec;
    if (sec < 10)
        sec = "0" + sec;

    const res = min + ":" + sec
    return res
}
</script>

<template>
    <div class="col">
        <div class="row">
            <img class="coin-lg" :src="getCoinUrl()" alt="">
            <h1>{{ stringNumber(storage.COINS) }}</h1>
        </div>
        <div class="col">
            <h3 :class="{ 'boosted': storage.BOOST_ON }">Speed: {{ stringNumber(earningsPerS) }}/s </h3>
            
            <button class="timer boost-btn action-btn" v-if="timerStr" disabled>{{ timerStr }}</button>
            <div v-else class="action-btn boost-btn" :class="{ 'disabled': !isBoostAvailable }" @click="toBoostUp">
                <template v-if="!nextBoostTimerStr">
                    <span>Boost </span>
                    <!-- <img class="boost-ad-icon" :src="adIconURL" alt=""> -->
                    <img class="coin-sm" v-show="isBoostAvailable" :src="getCoinUrl()" alt="">
                    <span> X {{ upgrades.extraBoost.values[storage.UPGRADES_LVLS.extraBoost] }}</span>
                </template>
<span v-else>{{ nextBoostTimerStr }}</span>
</div>
</div>
</div>
<!-- <img v-show="timerStr" src="/spacebar-clicker/assets/pics/arrow.svg" class="arrow-up" alt=""> -->
</template>

<style scoped>
.timer.boost-btn {
    background-color: rgb(147, 5, 5);
    color: white;
    box-shadow: none;
}

.col {
    overflow: visible;
}

.timer:hover {
    cursor: default;
}

.boost-btn.disabled {
    filter: brightness(0.7);
}

.boost-btn.disabled:hover {
    cursor: default;

}

.boost-btn:hover {
    cursor: pointer;
}

h3 {
    margin-top: 5px;
}

.col {
    overflow: visible;
}

.row {
    justify-content: center;
}

.boosted {
    color: red;
}

.header {
    position: absolute;
    top: 50px;
    right: 0;
    width: 100%;
    /* height: 300px; */
    display: flex;
    justify-content: flex-end;
}

.boost-btn {
    position: relative;
    overflow: visible;
    margin: 2px 10px;
    background-color: aqua;
    box-shadow: 0px 0px 11px 7px rgba(255, 255, 255, 0.881);
    /* display: flex;
    align-items: center; */
}

.boost-btn span {
    color: black;
    font-size: 1.1rem;
}

.arrow-up {
    height: 1.375rem;
    transform: scaleX(-1);
}

.coin-lg {
    height: 3.125rem;
}

@media screen and (max-width: 1200px) {

    h1 {
        margin-top: 1.25rem;
    }

    .col-to-row {
        flex-direction: row;
        align-items: baseline;
    }

    .col-to-row span {
        font-size: 1.2rem;
    }

}

@media screen and (max-height: 400px) {

    .coin-lg {
        height: 2rem;
    }

    h1 {
        margin: 0;
        font-size: 1.1rem;
    }


}
</style>